const styles = {
  chipIcon: {
    fontSize: '0.9rem !important',
    marginRight: '4px !important',
  },
};

export default styles;
